import { ALTER_ALERT, HIDE_ALERT, ALTER_ALERT_PARAM, SHOW_TXN_ALERT, HIDE_TXN_ALERT, SHOW_DROPDOWN_ALERT, HIDE_DROPDOWN_ALERT } from "../actions/alertAction";

const initialState = {
  showAlert: false,
  message: "",
  id: "",
  additionalItems: [],
  value: "",
  showTxnLimitAlert: false
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALTER_ALERT:
      return {
        ...state,
        showAlert: true,
        message: action.payload.message,
        id: action.payload.id,
        additionalItems: action.payload.additionalItems
      };
    case HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
      };
    case ALTER_ALERT_PARAM:
        return {
          ...state,
          showAlert: true,
          message: action.payload.message,
          id: action.payload.id,
          value: action.payload.value
    };
    case SHOW_TXN_ALERT:
        return {
          ...state,
          showTxnLimitAlert: true,
          message: action.payload.message,
          id: action.payload.id,
          value: action.payload.value
    };
    case HIDE_TXN_ALERT:
      return {
        ...state,
        showTxnLimitAlert: false,
      };

    case SHOW_DROPDOWN_ALERT:
        return {
          ...state,
          showDropdownAlert: true,
    };
    case HIDE_DROPDOWN_ALERT:
        return {
          ...state,
          showDropdownAlert: false,
    };

    default:
      return state;
  }
};

export default alertReducer;
